import { Component, OnInit } from "@angular/core";
import { Observable } from "rxjs";
import { Router, ActivatedRoute, Params } from "@angular/router";
import { map, startWith } from "rxjs/operators";
import { FormControl } from "@angular/forms";
import { POService } from "../../services/po.service";
import { Methods } from "../../shared/methods";
import { HdLinkToMasterService } from "../../services/hdlinktomaster.service";
import { formatDate } from "@angular/common";
import { CompanylinkedService } from "../../services/companylinked.service";

export interface UserList {
  value: string;
  name: string;
}

declare const $: any;

@Component({
  selector: "app-linktomaster",
  templateUrl: "./linktomaster.component.html",
  styleUrls: ["./linktomaster.component.css"],
  providers: [POService, HdLinkToMasterService, CompanylinkedService],
})
export class LinktomasterComponent implements OnInit {
  public token;

  public mtds: Methods = new Methods();

  public statusContainerHDDLink: boolean = false;
  public multipleHDD: boolean = false;
  public hdlinkshowEmptySearch = 0;
  public msgerrorhdlinkSearch = "";
  public companySelected;
  myControlCompanies = new FormControl();
  public loading: boolean = false;
  public destructionclientsname: string = "";
  public companySelected2;
  public poList: any[] = [];
  public poSelected;
  filteredCompanies: Observable<UserList[]>;
  public hdlinkpo = "";
  public hdlinkshowMsgSearchingNotResults = 0;
  public poshowMsgSearchingNotResults = 0;
  public responseHdLinkToMaster: any[] = [];
  public currentHdLink = 0;
  public hdLinkSerialRemove = "";
  public hdLinkAssetRemove = "";
  public contMasterItemHDD = 0;
  public contMasterItemNOTHDD = 0;
  public msgerrorhdlink = "";
  public SerialNumberMasterItem;
  public childAssetag;
  public childitemSerialNumber;
  public hdlinkshowEmpty = 0;
  public masterSaved;
  public addToMastershowMsgInfoResults = 0;
  public linkToMasterSaved = 0;
  public companies;
  companiesList: UserList[] = [];

  constructor(
    private _router: Router,
    private _poService: POService,
    private _companylinkedService: CompanylinkedService,
    private _hdLinkToMasterService: HdLinkToMasterService
  ) {
    this.token = JSON.parse(localStorage.getItem("token"));
    this.getAllCompanies();
  }

  ngOnInit() {
    this.filteredCompanies = this.myControlCompanies.valueChanges.pipe(
      startWith<string | UserList>(""),
      map((value) => (typeof value === "string" ? value : value.name)),
      map((name) =>
        name ? this._filterCompanies(name) : this.companiesList.slice()
      )
    );
  }

  private _filterCompanies(name: string): UserList[] {
    const filterValue = name.toLowerCase();

    return this.companiesList.filter((option) =>
      option.name.toLowerCase().includes(filterValue)
    );
  }

  getAllCompanies() {
    this._companylinkedService.getAllCompaniesLite(this.token, "all").subscribe(
      (response) => {
        console.log(response);
        if (response.status == "success") {
          this.companies = response.data;
          console.log(this.companies);
          response.data.forEach((element) => {
            this.companiesList.push({
              value: element.id,
              name: element.name + " # " + element.id,
            });
          });
        }
      },
      (error) => {
        console.log(<any>error);
      }
    );
  }

  containerHDDLink() {
    this.statusContainerHDDLink = !this.statusContainerHDDLink;
  }

  changeStatus(e) {
    this.multipleHDD = !e;
  }

  OnHumanSelected(event: any) {
    this.loading = true;
    var res = event.viewValue.split("#");
    this.companySelected = res[0].trim();

    let valorEnviar = res[1].trim();

    this.destructionclientsname = this.companySelected;
    this.companySelected2 = res[1].trim();
    $("#poInput").show();

    this._poService.getAllPOsLiteByCompany(this.token, valorEnviar).subscribe(
      (response) => {
        if (
          response.code === 400 &&
          response.msg === "Authorization not valid"
        ) {
          this.mtds.notifyError("Your session has expired");
          localStorage.clear();
          this._router.navigate(["/pages/lock"]);
        } else if (response.status == "success") {
          this.loading = false;
          this.poList = response.data;
          this.poSelected = "";
        }
      },
      (error) => {
        console.log(<any>error);
      }
    );
  }

  public reporteID = null;

  selectChangeHandler(event: any) {
    this.poSelected =
      event.target.options[event.target.options.selectedIndex].text;

    this.hdlinkshowEmptySearch = 0;
    if (this.companySelected == undefined || this.hdlinkpo == "") {
      this.hdlinkshowEmptySearch = 1;
      this.msgerrorhdlinkSearch = "You must filled, company and po fields";
      return;
    }

    console.log(this.poSelected);

    $("#hdLinkToMastershowMsgSearching").show();

    this.hdlinkshowMsgSearchingNotResults = 0;
    $("#hdlinktoMasterdresults").hide();
    let dataEnviar = {
      companies_id: this.companySelected2,
      po_id: this.hdlinkpo,
    };
    console.log(dataEnviar);

    this._hdLinkToMasterService.getReport(this.token, this.poSelected).subscribe(
      r => {
        console.log(r);
        if (r.code === 404) {
          this._hdLinkToMasterService.newReport(this.token, this.poSelected).subscribe(
            resp => {
              console.log(resp);
              this.reporteID = resp.data.id;
              $("#hdLinkToMastershowMsgSearching").hide();
            }, error => {
              console.log(error);
              $("#hdLinkToMastershowMsgSearching").hide();
            }
          );
        } else if (r.code === 200) {
          this.reporteID = r.data.id;
          this.getElements();
          $("#hdLinkToMastershowMsgSearching").hide();
        } else {
          this.mtds.notifyError(r.msg);
          $("#hdLinkToMastershowMsgSearching").hide();
        }
      }, err => {
        console.log(err)
        $("#hdLinkToMastershowMsgSearching").hide();
      }
    );
    /*
    this._hdLinkToMasterService
      .searchHDLinkToMaster(this.token, dataEnviar)
      .subscribe(
        (response) => {
          console.log(response);

          if (response.status == "success") {
            $("#companyInput").show();
            $("#poInput").show();
            $("#companyform").hide();
            $("#poform").hide();

            $("#hdLinkToMastershowMsgSearching").hide();

            this.poshowMsgSearchingNotResults = 0;
            this.responseHdLinkToMaster = JSON.parse(response.data.data);
            this.currentHdLink = response.data.id;
            this.hdLinkSerialRemove = response.data.numSerieMaster;
            this.hdLinkAssetRemove = response.data.assetag;

            console.log(this.responseHdLinkToMaster);
            var count = {};
            this.contMasterItemHDD = this.responseHdLinkToMaster.length;

            this.responseHdLinkToMaster.forEach(
              (number) => (count[number.childitemSerialNumber] = (count[number.childitemSerialNumber] || 0) + 1)
            );
            if (typeof count["NA"] !== "undefined")
              this.contMasterItemHDD = this.contMasterItemHDD - count["NA"];
            if (typeof count["N/A"] !== "undefined")
              this.contMasterItemHDD = this.contMasterItemHDD - count["N/A"];
            if (typeof count["n/a"] !== "undefined")
              this.contMasterItemHDD = this.contMasterItemHDD - count["n/a"];
            console.log(count);

            this.contMasterItemNOTHDD =
              this.responseHdLinkToMaster.length - this.contMasterItemHDD;

            $("#hdlinktoMasterdresults").show();
          } else {
            $("#companyInput").hide();
            $("#poInput").hide();
            $("#companyform").show();
            $("#poform").show();
            $("#hdLinkToMastershowMsgSearching").hide();
            this.hdlinkshowMsgSearchingNotResults = 1;
            this.msgerrorhdlinkSearch = "No records found, please try again";
            this.msgerrorhdlink = "No records found, please try again";
            return;
          }
        },
        (error) => {
          console.log(<any>error);
        }
      );
      */
  }

  getElements() {
    this.loading = true;
    this._hdLinkToMasterService.listElementsByReport(this.token, this.reporteID).subscribe(
      r => {
        console.log(r);
        if (r.status == "success") {
          $("#companyInput").show();
          $("#poInput").show();
          $("#companyform").hide();
          $("#poform").hide();

          $("#hdLinkToMastershowMsgSearching").hide();

          this.poshowMsgSearchingNotResults = 0;
          this.responseHdLinkToMaster = [];
          for (let item of r.data) {
            let element = JSON.parse(item.data);
            element.id = item.id;
            this.responseHdLinkToMaster.push(element);
          }
          // this.responseHdLinkToMaster = r.data;
          // this.currentHdLink = r.data.id;
          // this.hdLinkSerialRemove = r.data.numSerieMaster;
          // this.hdLinkAssetRemove = r.data.assetag;

          console.log(this.responseHdLinkToMaster);
          var count = {};
          this.contMasterItemHDD = this.responseHdLinkToMaster.length;

          this.responseHdLinkToMaster.forEach(
            (number) => (count[number.childitemSerialNumber] = (count[number.childitemSerialNumber] || 0) + 1)
          );
          if (typeof count["NA"] !== "undefined")
            this.contMasterItemHDD = this.contMasterItemHDD - count["NA"];
          if (typeof count["N/A"] !== "undefined")
            this.contMasterItemHDD = this.contMasterItemHDD - count["N/A"];
          if (typeof count["n/a"] !== "undefined")
            this.contMasterItemHDD = this.contMasterItemHDD - count["n/a"];
          console.log(count);

          this.contMasterItemNOTHDD =
            this.responseHdLinkToMaster.length - this.contMasterItemHDD;

          $("#hdlinktoMasterdresults").show();
        } else {
          $("#companyInput").hide();
          $("#poInput").hide();
          $("#companyform").show();
          $("#poform").show();
          $("#hdLinkToMastershowMsgSearching").hide();
          this.hdlinkshowMsgSearchingNotResults = 1;
          this.msgerrorhdlinkSearch = "No records found, please try again";
          this.msgerrorhdlink = "No records found, please try again";
          return;
        }
        this.loading = false;
        this.removing = null;
      }
    );
  }

  AddToMaster() {

    this.linkToMasterSaved = 0;
    console.log(this.hdlinkpo);

    let fechaHoy = formatDate(new Date(), "MM/dd/yyyy", "en");
    var myJSON = this.responseHdLinkToMaster;

    let dataEnviar = {
      id: Math.floor(Math.random() * 100 + 1),
      SerialNumberMAster: this.SerialNumberMasterItem,
      AssetTag: this.childAssetag,
      SerialNumber: this.childitemSerialNumber,
      clientsname: this.destructionclientsname
    };

    this._hdLinkToMasterService.newElementForReport(this.token, this.reporteID, dataEnviar).subscribe(
      r => {
        console.log(r);

        if (r.code === 200) {
          this.getElements();
          this.SerialNumberMasterItem = '';
          this.childAssetag = '';
          this.childitemSerialNumber = '';
          $("#SerialNumberMasterItem").focus();
        } else {
          this.mtds.notifyError(r.msg);
        }
      }
    );
  }

  AddToChild() {

    this.hdlinkshowEmpty = 0;
    if (this.companySelected == undefined || this.hdlinkpo == "") {
      this.hdlinkshowEmpty = 1;
      this.msgerrorhdlink = "You must filled, company and po fields";
      return;
    }

    if (
      this.SerialNumberMasterItem == undefined ||
      this.childAssetag == undefined ||
      this.childitemSerialNumber == undefined
    ) {
      this.hdlinkshowEmpty = 1;
      this.msgerrorhdlink = "You must filled, all the fields";
      return;
    }

    if (this.childitemSerialNumber == "") {
      this.hdlinkshowEmpty = 1;
      this.msgerrorhdlink = "You must filled, all the fields";
      return;
    }

    this.masterSaved = 0;
    this.addToMastershowMsgInfoResults = 0;

    let idrandom = Math.floor(Math.random() * 100 + 1);
    this.SerialNumberMasterItem = this.SerialNumberMasterItem.replace(".", "");
    this.childitemSerialNumber = this.childitemSerialNumber.replace(".", "");
    let localSerialNumberMasterItem = this.SerialNumberMasterItem;

    var found = this.responseHdLinkToMaster.find(function (element) {
      console.log(element);
      return element.SerialNumberMasterItem == localSerialNumberMasterItem;
    });
    console.log(found);
    if (found) {
      this.addToMastershowMsgInfoResults = 1;
      return true;
    }

    let Enviar = {
      id: Math.floor(Math.random() * 100 + 1),
      SerialNumberMAster: this.SerialNumberMasterItem,
      AssetTag: this.childAssetag,
      SerialNumber: this.childitemSerialNumber,
      clientsname: this.destructionclientsname
    };

    this._hdLinkToMasterService.newElementForReport(this.token, this.reporteID, Enviar).subscribe(
      r => {
        console.log(r);
        if (r.code === 200) {
          this.getElements();
          this.childitemSerialNumber = '';
          $("#childitemSerialNumber").focus();
        } else {
          this.mtds.notifyError(r.msg);
        }
      }
    );
  }

  searchInterest(e) {
    if (e.key == "Enter" && this.SerialNumberMasterItem != "")
      $("#childAssetag").focus();
  }

  searchInterest2(e) {
    if (e.key == "Enter") $("#childitemSerialNumber").focus();
  }
/*
  AddToMaster() {
    this.hdlinkshowEmpty = 0;
    if (this.companySelected == undefined || this.hdlinkpo == "") {
      this.hdlinkshowEmpty = 1;
      this.msgerrorhdlink = "You must filled, company and po fields";
      return;
    }

    if (
      this.SerialNumberMasterItem == undefined ||
      this.childAssetag == undefined ||
      this.childitemSerialNumber == undefined
    ) {
      this.hdlinkshowEmpty = 1;
      this.msgerrorhdlink = "You must filled, all the fields";
      return;
    }

    if (this.childitemSerialNumber == "") {
      this.hdlinkshowEmpty = 1;
      this.msgerrorhdlink = "You must filled, all the fields";
      return;
    }

    this.masterSaved = 0;
    this.addToMastershowMsgInfoResults = 0;

    let idrandom = Math.floor(Math.random() * 100 + 1);
    this.SerialNumberMasterItem = this.SerialNumberMasterItem.replace(".", "");
    this.childitemSerialNumber = this.childitemSerialNumber.replace(".", "");
    let localSerialNumberMasterItem = this.SerialNumberMasterItem;

    var found = this.responseHdLinkToMaster.find(function (element) {
      console.log(element);
      return element.SerialNumberMasterItem == localSerialNumberMasterItem;
    });
    console.log(found);
    if (found) {
      this.addToMastershowMsgInfoResults = 1;
      return true;
    }

    let Enviar = {
      id: idrandom,
      SerialNumberMasterItem: this.SerialNumberMasterItem,
      assetag: this.childAssetag,
      childitemSerialNumber: this.childitemSerialNumber,
    };

    console.log(Enviar);

    this.responseHdLinkToMaster.unshift(Enviar);
    Enviar = null;
    $("#hdlinktoMasterdresults").show();
    this.saveMasterItem();

    this.childitemSerialNumber = "";
    this.childAssetag = "";
    this.SerialNumberMasterItem = "";
    $("#poInput").show();
    $("#companyform").hide();
    $("#poform").hide();
  }
*/
  saveMasterItem() {
    this.linkToMasterSaved = 0;
    console.log(this.hdlinkpo);

    let fechaHoy = formatDate(new Date(), "MM/dd/yyyy", "en");
    var myJSON = JSON.stringify(this.responseHdLinkToMaster);

    let dataEnviar = {
      companyLinked: this.companySelected2,
      po: this.hdlinkpo,
      numSerieMaster: this.SerialNumberMasterItem,
      assetag: this.childAssetag,
      name: fechaHoy,
      data: myJSON,
    };

    console.log(dataEnviar);

    if (this.currentHdLink > 0) {
      this._hdLinkToMasterService
        .update(this.token, this.currentHdLink, dataEnviar)
        .subscribe(
          (response) => {
            console.log(response);

            if (response.status == "success") {
              this.showNotification("bottom", "right");

              this.masterSaved = 1;
              this.currentHdLink = response.data.id;
              this.hdLinkSerialRemove = response.data.numSerieMaster;
              this.hdLinkAssetRemove = response.data.assetag;
            } else {
              this.showNotificationError("bottom", "right");
            }
          },
          (error) => {
            console.log(<any>error);
          }
        );
    } else {
      this._hdLinkToMasterService.new(this.token, dataEnviar).subscribe(
        (response) => {
          console.log(response);
          if (response.status == "success") {
            this.masterSaved = 1;
            this.currentHdLink = response.data.id;
            this.hdLinkSerialRemove = response.data.numSerieMaster;
            this.hdLinkAssetRemove = response.data.assetag;
            console.log(this.currentHdLink);
          }
        },
        (error) => {
          console.log(<any>error);
        }
      );
    }

    var count = {};
    this.contMasterItemHDD = this.responseHdLinkToMaster.length;

    this.responseHdLinkToMaster.forEach(
      (number) =>
        (count[number.childitemSerialNumber] =
          (count[number.childitemSerialNumber] || 0) + 1)
    );
    if (typeof count["NA"] !== "undefined")
      this.contMasterItemHDD = this.contMasterItemHDD - count["NA"];
    if (typeof count["N/A"] !== "undefined")
      this.contMasterItemHDD = this.contMasterItemHDD - count["N/A"];
    if (typeof count["n/a"] !== "undefined")
      this.contMasterItemHDD = this.contMasterItemHDD - count["n/a"];
    console.log(count);

    this.contMasterItemNOTHDD =
      this.responseHdLinkToMaster.length - this.contMasterItemHDD;

    $("#SerialNumberMasterItem").focus();
  }
/*
  AddToChild() {
    this.hdlinkshowEmpty = 0;
    if (this.companySelected == undefined || this.hdlinkpo == "") {
      this.hdlinkshowEmpty = 1;
      this.msgerrorhdlink = "You must filled, company and po fields";
      return;
    }

    if (
      this.SerialNumberMasterItem == undefined ||
      this.childAssetag == undefined ||
      this.childitemSerialNumber == undefined
    ) {
      this.hdlinkshowEmpty = 1;
      this.msgerrorhdlink = "You must filled, all the fields";
      return;
    }

    if (this.childitemSerialNumber == "") {
      this.hdlinkshowEmpty = 1;
      this.msgerrorhdlink = "You must filled, all the fields";
      return;
    }

    this.masterSaved = 0;
    this.addToMastershowMsgInfoResults = 0;

    let idrandom = Math.floor(Math.random() * 100 + 1);
    this.SerialNumberMasterItem = this.SerialNumberMasterItem.replace(".", "");
    this.childitemSerialNumber = this.childitemSerialNumber.replace(".", "");
    let localchilditemSerialNumber = this.childitemSerialNumber;

    var found = this.responseHdLinkToMaster.find(function (element) {
      console.log(element);
      return element.childitemSerialNumber == localchilditemSerialNumber;
    });
    console.log(found);
    if (found) {
      this.addToMastershowMsgInfoResults = 1;
      return true;
    }

    let Enviar = {
      id: idrandom,
      SerialNumberMasterItem: this.SerialNumberMasterItem,
      assetag: this.childAssetag,
      childitemSerialNumber: this.childitemSerialNumber,
    };

    console.log(Enviar);

    this.responseHdLinkToMaster.unshift(Enviar);
    Enviar = null;
    $("#hdlinktoMasterdresults").show();
    this.saveMasterItem();
    this.childitemSerialNumber = "";
    $("#companyInput").show();
    $("#poInput").show();
    $("#companyform").hide();
    $("#poform").hide();

    $("#childitemSerialNumber").focus();
  }
*/

  public removing = null;
  removeElementFromHDLinkTable(e) {
    console.log(e);
    this.removing = e.id;
    this._hdLinkToMasterService.removeElementFromReport(this.token, e.id).subscribe(
      r => {
        console.log(r);
        this.getElements();
      }, error => { this.removing = null; }
    );
  }

  showNotificationError(from: any, align: any) {

    $.notify(
      {
        icon: "notifications",
        message: "There is an error",
      },
      {
        type: "danger",
        timer: 500,
        placement: {
          from: from,
          align: align,
        },
        template:
          '<div data-notify="container" class="col-xs-11 col-sm-3 alert alert-{0} alert-with-icon" role="alert">' +
          '<button mat-raised-button type="button" aria-hidden="true" class="close" data-notify="dismiss">  <i class="material-icons">close</i></button>' +
          '<i class="material-icons" data-notify="icon">notifications</i> ' +
          '<span data-notify="title">{1}</span> ' +
          '<span data-notify="message">{2}</span>' +
          '<div class="progress" data-notify="progressbar">' +
          '<div class="progress-bar progress-bar-{0}" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style="width: 0%;"></div>' +
          "</div>" +
          '<a href="{3}" target="{4}" data-notify="url"></a>' +
          "</div>",
      }
    );
  }

  showNotification(from: any, align: any) {

    $.notify(
      {
        icon: "notifications",
        message: "HDD has been linked successfully",
      },
      {
        type: "success",
        timer: 500,
        placement: {
          from: from,
          align: align,
        },
        template:
          '<div data-notify="container" class="col-xs-11 col-sm-3 alert alert-{0} alert-with-icon" role="alert">' +
          '<button mat-raised-button type="button" aria-hidden="true" class="close" data-notify="dismiss">  <i class="material-icons">close</i></button>' +
          '<i class="material-icons" data-notify="icon">notifications</i> ' +
          '<span data-notify="title">{1}</span> ' +
          '<span data-notify="message">{2}</span>' +
          '<div class="progress" data-notify="progressbar">' +
          '<div class="progress-bar progress-bar-{0}" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style="width: 0%;"></div>' +
          "</div>" +
          '<a href="{3}" target="{4}" data-notify="url"></a>' +
          "</div>",
      }
    );
  }
}
